import * as Dialog from '@radix-ui/react-dialog'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { Button } from '../Button'
import { Icon } from '../Icon'
import * as styles from './styles'

/**
 * @note This **MUST NOT** be rendered inside Modal `<Body>`; its positioning within Modal `<Content>` depends on it
 * being a sibling to `<Body>`.
 */
export const Close = forwardRef<
  ElementRef<typeof Dialog.Close>,
  ComponentPropsWithoutRef<typeof Dialog.Close>
>((props, forwardedRef) => {
  return (
    <Dialog.Close
      className={styles.classes.close}
      asChild
      {...props}
      ref={forwardedRef}
    >
      <Button
        ariaLabel="Close"
        css={styles.modalClose}
        icon={<Icon glyph="gem-close" />}
        name="Close"
        variant="ghost"
      />
    </Dialog.Close>
  )
})
Close.displayName = 'Lapidary: Close ← Modal'
